import React from 'react';

export const TwitterLogo: React.FC<{}> = () => (
	<svg
		viewBox="0 0 28 28"
		fill="currentColor"
		stroke="none"
		strokeWidth="1"
		xmlns="http://www.w3.org/2000/svg">
		<path
			id="Vector"
			d="M25.9268 26.2685L16.0846 11.9609L24.6054 2.02197L26.3426 0H23.8592L22.1221 2.02197L14.9797 10.3548L9.2498 2.02197L7.85435 0H5.6729H1.93653H0V0.324654L1.17331 2.02766L10.4972 15.5834L1.33279 26.2685L0 27.8177V28H2.32954L3.81611 26.2685L11.6021 17.1896L17.8503 26.2685L19.0407 28H21.1937H24.93H27.1115L25.9268 26.2685ZM3.32628 2.02197H7.06265L13.7665 11.7616L11.6932 14.1823L3.32628 2.02197ZM20.009 26.2685L12.7982 15.7884L14.8714 13.3678L23.7453 26.2628H20.009V26.2685Z"
		/>
		<rect width="27.1229" fill="transparent" />
	</svg>
);
